// @flow
type UseOneTimeDisplayResponse = [boolean, Function];

export default function useOneTimeDisplay(
  namespace: string,
  key: string
): UseOneTimeDisplayResponse {
  const localStorageKey = `${namespace}/${key}`;
  const previouslyDisplayed =
    !localStorage || localStorage.getItem(localStorageKey) === 'true';
  const setPreviouslyDisplayed = () =>
    localStorage && localStorage.setItem(localStorageKey, 'true');

  return [previouslyDisplayed, setPreviouslyDisplayed];
}
